// src/store/useSideNavStore.js
import { create } from 'zustand';

const useSideNavStore = create((set) => ({
  isSidenav: true,
  toggleSidenav: () => set((state) => ({ isSidenav: !state.isSidenav })),
  setSidenav: (value) => set({ isSidenav: value }),
}));

export default useSideNavStore;
